import { cva, type VariantProps } from 'class-variance-authority';
import { Dialog as DialogPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from '../../lib/cn.ts';

export const Sheet = DialogPrimitive.Root;
export const SheetTrigger = DialogPrimitive.Trigger;
export const SheetClose = DialogPrimitive.Close;
export const SheetTitle = DialogPrimitive.Title;
export const SheetDescription = DialogPrimitive.Description;

const sheetVariants = cva(
  'fixed z-50 flex flex-col gap-3 bg-card p-4 text-card-foreground shadow-lg',
  {
    variants: {
      side: {
        left: 'inset-y-0 left-0 w-72 max-w-[85vw] border-r',
        bottom: 'inset-x-0 bottom-0 max-h-[85vh] overflow-y-auto rounded-t-lg border-t',
      },
    },
    defaultVariants: { side: 'left' },
  },
);

/** A drawer: the navigation on narrow screens (left) and the filters on phones (bottom sheet). */
export function SheetContent({
  className,
  side,
  children,
  ...props
}: ComponentProps<typeof DialogPrimitive.Content> & VariantProps<typeof sheetVariants>) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-foreground/40" />
      <DialogPrimitive.Content className={cn(sheetVariants({ side }), className)} {...props}>
        {children}
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  );
}
